import store from '../store';

export const authGuard = (to, from, next) => {

  if (to?.query?.signature === process.env.VUE_APP_TDC_2_SIGNATURE) {
    store.dispatch('setAuthTrue').then(
      next()
    );
  }

  if (store.state.authenticated) {
    return next();
  } else {
    return next('/');
  }
};